import { render } from "./PredictionContainerComponent.vue?vue&type=template&id=e18340a4&ts=true"
import script from "./PredictionContainerComponent.vue?vue&type=script&lang=ts"
export * from "./PredictionContainerComponent.vue?vue&type=script&lang=ts"

import "./PredictionContainerComponent.vue?vue&type=style&index=0&id=e18340a4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__